export function intervalTimeSum(hours, minutes) {
    return hours * 60 + minutes;
}
export function intervalStartTimeSum({ start_hour = 0, start_min = 0, }) {
    return intervalTimeSum(start_hour, start_min);
}
export function intervalEndTimeSum({ end_hour = 0, end_min = 0, }) {
    return intervalTimeSum(end_hour, end_min);
}
export function getScheduleMarkUpsOffsets(labels) {
    const result = [];
    const offset = 100 / (labels.length - 1);
    labels.forEach((label, index) => {
        result.push({ offset: index * offset, label });
    });
    return result;
}
export const getCorrectIntervalUIValue = (baxiValues, zontValues, is_baxi_app) => {
    return is_baxi_app ? baxiValues : zontValues;
};
export const getBaxiIntervalSize = (size, need_pixels) => {
    const width = '100%';
    const height = convertIntervalSizeMeasure(size, need_pixels);
    return { width, height };
};
export const getZontIntervalSize = (size, need_pixels) => {
    const width = convertIntervalSizeMeasure(size, need_pixels);
    const height = '100%';
    return { height, width };
};
export const getBaxiIntervalOffset = (offset, need_pixels) => {
    const top = convertIntervalSizeMeasure(offset, need_pixels);
    const left = '0px';
    return { top, left };
};
export const getZontIntervalOffset = (offset, need_pixels) => {
    const left = convertIntervalSizeMeasure(offset, need_pixels);
    const top = '0px';
    return { left, top };
};
export function getBaxiDevidedIntervalSize() {
    const width = '75%';
    const height = 'auto';
    return { width, height };
}
export function getZontDevidedIntervalSize() {
    const width = 'auto';
    const height = '100%';
    return { width, height };
}
export const getBaxiIntervalSpacing = (first_spacing_condition, second_spacing_condition, week_view) => {
    const top = getIntervalSpacing(first_spacing_condition, week_view);
    const bottom = getIntervalSpacing(second_spacing_condition, week_view);
    const left = '0px';
    const right = '0px';
    return { top, bottom, left, right };
};
export const getZontIntervalSpacing = (first_spacing_condition, second_spacing_condition, week_view) => {
    const left = getIntervalSpacing(first_spacing_condition, week_view);
    const right = getIntervalSpacing(second_spacing_condition, week_view);
    const top = '0px';
    const bottom = '0px';
    return { right, left, top, bottom };
};
export function getIntervalSpacing(horizontal_devided_interval_spacing, week_view) {
    if (horizontal_devided_interval_spacing) {
        return '3.5px';
    }
    return week_view ? '1px' : '10px';
}
export function isIntervalsHorizontal(direction) {
    return direction === 'horizontal';
}
export function convertIntervalSizeMeasure(value, need_pixels) {
    return need_pixels ? `${value}px` : `${value}%`;
}
export function compareInterval(a, b) {
    //Если начало B раньше начала A
    const a_sum = intervalStartTimeSum(a);
    const b_sum = intervalStartTimeSum(b);
    if (a_sum < b_sum) {
        //Тогда развернём
        return -1;
    }
    //Если начало A раньше начала B
    if (a_sum > b_sum) {
        return 1;
    }
    return 0;
}
